import React, { createRef } from "react";
import { Link } from "react-router-dom";
import VopFooter from "components/vop_footer";
import "./style.scss";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.headerRef = createRef();
  }
  componentDidMount() {
    document.title = "京东VOP开放平台-登录";

    if (this.headerRef.current) {
      this.headerRef.current.style.width = window.innerWidth <= 1200 ? '100%' : '1200px';
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="login-wrapper">
          <div className="login-header">
            <div className="login-content" ref={this.headerRef}>
              <Link to="/">
                <img
                  src="https://img14.360buyimg.com/imagetools/jfs/t1/132290/20/11897/2611/5f7ffc6bE6d622634/2e8dcd84cd96ccfc.png"
                  alt=""
                />
              </Link>
            </div>
          </div>
          <div className="login-center">
            <img
              src="https://img12.360buyimg.com/imagetools/jfs/t1/154446/4/6060/246661/5fb2378bE984457cc/5b54b8b75228d098.jpg"
              alt=""
            />
            <div className="login-content">
              <div className="login-info">
                <div className="logo">
                  <img
                    src="https://img11.360buyimg.com/imagetools/jfs/t1/146039/28/14853/6632/5fb4c462Ec64195e8/2ad7fad3ba699d95.png"
                    alt=""
                  />
                </div>
                <div className="title">具备PaaS级接口对接能力</div>
                <div className="desc">适用于有自建商城诉求的企业</div>
                <div className="desc">实现企业和供应商之间的高效协同</div>
              </div>
              <div className="login-iframe">
                <div className="title">账户登录</div>
                <iframe
                  title="登录"
                  // src="http://passport.jd.com/common/loginPage?from=bvop_pc&regTag=2&pwdTag=2&btnTag=C196FA243B92A634E69E58421D3A69881E0361DE75D6C663&ReturnUrl=https://vop.jd.com/passport/middle"
                  src="https://passport.jd.com/common/loginPage?from=bvop_pc&regTag=2&pwdTag=2&btnTag=84c2d04dc412f846&ReturnUrl=https://vop.jd.com/passport/middle"
                  frameBorder="0"
                  width="370"
                  height="340"
                ></iframe>
                <div className="register">
                  <div className="register-box">
                      <div><a href="https://aq.jd.com/process/findPwd?s=39&returnURL=https://vop.jd.com/passport/login">
                        忘记密码
                        </a></div>
                      <div>
                        没有账号？<a href="http://reg.jd.com/e/common/regPage?source=bvop_pc&ReturnUrl=https://vop.jd.com/passport/middle">立即注册&gt;</a>
                      </div>
                  </div>
                  
                  
                </div>
              </div>
            </div>
          </div>
          <div className="login-footer">
            <VopFooter />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Login;
